import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

//Start Css code ...
const useStyles = makeStyles({  
  mainbtnDiv:{
    border:'1px solid #24618E',
    borderTop:'none',
    borderRadius:'0px 0px 5px 5px',
    minHeight:'365px',
    '& .focusBtn':{
      color: "#fff",
      background: '#24618E',
    }    
  }

});
//End Css code ...

//Start ExternalLayers component code ...
const ExternalLayers = () =>{
  const classes = useStyles();
    return (
      <React.Fragment>
        <div className={classes.mainbtnDiv} style={{padding: '10px'}}>
      <h4>Available layers</h4>
      <ul>
        <li>Boundaries</li>
        <li>DEP</li>
      </ul>
      </div>
     </React.Fragment>
    );
  }
  
  export default ExternalLayers;

  //End ExternalLayers component code ...
